import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface Props {
  children: ReactNode;
  className?: string;
}

export default function AvatarDecoration({ children, className }: Props) {
  return (
    <div
      className={cn(
        "shadow border border-white border-opacity-30 rounded-2xl",
        className,
      )}
    >
      {children}
    </div>
  );
}
